// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

const SessionStart = () => import('@/components/SessionStart')
const SessionJump = () => import('@/components/SessionJump')
const SessionContainer = () => import('@/components/SessionContainer')
const AuthToken = () => import('@/components/AuthToken')
const Logout = () => import('@/components/Logout')
const FaqDetails = () => import('@/components/FaqDetails')
const FaqSearch = () => import('@/components/FaqSearch')
const Chatbot = () => import('@/components/Chatbot')
const ChatbotEmbed = () => import('@/components/ChatbotEmbed')
const FaqTopics = () => import('@/components/FaqTopics')
const Faqs = () => import('@/components/Faqs')
const Products = () => import('@/components/Products')
const ProductDetails = () => import('@/components/ProductDetails')
const Undo = () => import('@/components/Undo')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'session-start',
      component: SessionStart,
      beforeEnter: (to, from, next) => {
        if (store.getters.isSessionValid) {
          if (to.query.is_chatbot_embed === 'true') {
            next({ name: 'chatbot-embed', query: to.query })
          } else {
            next({name: 'session', query: to.query})
          }
        } else {
          next()
        }
      }
    },
    {
      path: '/start/:step',
      name: 'session-start-jump',
      component: SessionStart,
      beforeEnter: (to, from, next) => {
        if (store.getters.isSessionValid) {
          const step = to.params.step || ''
          next({name: 'session-jump', params: {step: step}, query: to.query})
        } else {
          next()
        }
      }
    },
    {
      path: '/step/:step',
      name: 'session-jump',
      component: SessionJump,
      beforeEnter: (to, from, next) => {
        if (store.getters.isSessionValid) {
          if (store.state.session['can_jump']) {
            next()
          } else {
            next({name: 'session', query: to.query})
          }
        } else {
          const step = to.params.step || ''
          next({name: 'session-start-jump', params: {step: step}, query: to.query})
        }
      }
    },
    {
      path: '/topics',
      name: 'faq-topics',
      component: FaqTopics,
      meta: {
        breadcrumbs: [
          {label: 'Main Menu', path: {name: 'session'}, home: true}
        ],
        requireRedirectForHome: true
      }
    },
    {
      path: '/faqs',
      name: 'faqs',
      component: Faqs,
      meta: {
        breadcrumbs: [
          {label: 'Main Menu', path: {name: 'session'}, home: true},
          {label: 'Topics', path: {name: 'faq-topics'}}
        ],
        requireRedirectForHome: true
      }
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
      props: true,
      meta: {
        breadcrumbs: [
          {label: 'Main Menu', path: {name: 'session'}, home: true}
        ],
        requireRedirectForHome: true
      }
    },
    {
      path: '/products/:id/:slug',
      name: 'product-details',
      component: ProductDetails,
      props: true,
      meta: {
        breadcrumbs: [
          {label: 'Main Menu', path: {name: 'session'}, home: true},
          {label: 'Products', path: {name: 'products'}}
        ],
        requireRedirectForHome: true
      }
    },
    {
      path: '/faqs/search',
      name: 'faq-search',
      component: FaqSearch,
      meta: {
        breadcrumbs: [
          {label: 'Main Menu', path: {name: 'session'}, home: true},
          {label: 'Topics', path: {name: 'faq-topics'}}
        ],
        requireRedirectForHome: true
      }
    },
    {
      path: '/faqs/:slug',
      name: 'faq-details',
      component: FaqDetails,
      meta: {
        breadcrumbs: [
          {label: 'Main Menu', path: {name: 'session'}, home: true},
          {label: 'Topics', path: {name: 'faq-topics'}, home: true},
          {label: 'Faqs', path: {name: 'faqs'}}
        ],
        requireRedirectForHome: true
      }
    },
    {
      path: '/:uid-:token',
      name: 'session-auth',
      component: AuthToken
    },
    {
      path: '/:uid-:token/start/:step',
      component: AuthToken
    },
    {
      path: '/:uid-:token/step/:step',
      component: AuthToken
    },
    {
      path: '/session/:step?',
      name: 'session',
      component: SessionContainer,
      beforeEnter: (to, from, next) => {
        if (store.getters.isSessionValid) {
          next()
        } else {
          next({name: 'session-start', query: to.query})
        }
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/chat',
      name: 'chatbot',
      component: Chatbot,
      beforeEnter: (to, from, next) => {
        if (store.getters.isSessionValid) {
          next()
        } else {
          next({name: 'session-start', query: to.query})
        }
      }
    },
    {
      path: '/chatbot_embed',
      name: 'chatbot-embed',
      component: ChatbotEmbed,
      beforeEnter: (to, from, next) => {
        if (store.getters.isSessionValid) {
          next()
        } else {
          next({name: 'session-start', query: Object.assign({}, to.query, {is_chatbot_embed: true})})
        }
      }
    },
    {
      path: '/profiler_enable',
      beforeEnter: (to, from, next) => {
        // enable profiling and return to session
        store.commit('profiler_enable', true)
        console.log('profiler enabled')
        next({name: 'session'})
      }
    },
    {
      path: '/profiler_disable',
      beforeEnter: (to, from, next) => {
        // disable profiling and return to session
        store.commit('profiler_enable', false)
        console.log('profiler disabled')
        next({name: 'session'})
      }
    },
    {
      path: '/cprofiler_enable',
      beforeEnter: (to, from, next) => {
        // enable cprofiling and return to session
        store.commit('cprofiler_enable', true)
        console.log('cprofiler enabled')
        next({name: 'session'})
      }
    },
    {
      path: '/cprofiler_disable',
      beforeEnter: (to, from, next) => {
        // disable cprofiling and return to session
        store.commit('cprofiler_enable', false)
        console.log('cprofiler disabled')
        next({name: 'session'})
      }
    },
    {
      path: '/debug_enable',
      beforeEnter: (to, from, next) => {
        // enable cprofiling and return to session
        store.commit('debug_enable', true)
        console.log('debug_enabled')
        next({name: 'session'})
      }
    },
    {
      path: '/debug_disable',
      beforeEnter: (to, from, next) => {
        // disable cprofiling and return to session
        store.commit('debug_enable', false)
        console.log('debug disabled')
        next({name: 'session'})
      }
    },
    {
      path: '/undo/:step?',
      name: 'undo',
      component: Undo
    }
  ]
})

export default router
